import {
  Component, Inject, OnDestroy, OnInit,
} from '@angular/core';
import {
  MAT_DIALOG_DATA, MatDialog, MatDialogRef,
} from '@angular/material/dialog';
import { VerificationComponent } from 'src/app/components/verification/verification.component';
import { CoursesService } from 'src/app/services/courses.service';
import { ToastService } from 'src/app/services/toast.service';

@Component({
  selector: 'app-update-requirement-modal',
  templateUrl: './update-requirement-modal.component.html',
  styleUrls: ['./update-requirement-modal.component.scss'],
})
export class UpdateRequirementModalComponent implements OnInit, OnDestroy {
  requirementOptions: any;
  courseRequirements: any;
  courseDataSubscription: any;
  userCourseRequirementSubscription: any;
  selectedRequirement: any;
  selectedUser: any;

  constructor(
    private toastService: ToastService,
    private coursesService: CoursesService,
    public dialogRef: MatDialogRef<UpdateRequirementModalComponent>,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) { }

  ngOnInit(): void {
    this.selectedUser = this.data.user;
    this.selectedRequirement = this.data.selectedRequirementId;

    // Start with unassigned option as default
    this.requirementOptions = [{ value: null, text: 'Unassigned/Portfolio' }];

    // Get course item requirements to populate the dropdown
    const courseItemId = this.data?.course?.courseItemId;
    if (courseItemId) {
      this.coursesService.getCourseSession(courseItemId, { includedAssociations: 'Requirements' });
      this.courseDataSubscription = this.coursesService.courseSessionData$.subscribe((courseData: any) => {
        if (courseData && courseData.Requirements) {
          this.courseRequirements = courseData.Requirements;

          // Filter course requirements to only include those that exist in user requirements
          const filteredCourseRequirements = this.courseRequirements.filter((courseRequirement: any) =>
            this.data?.userRequirements?.findIndex((userRequirement: any) => {
              return courseRequirement?.requirementId.toString() === userRequirement?.requirementId.toString();
            }) !== -1);

          // Map filtered course requirements to dropdown options
          const courseRequirementOptions = filteredCourseRequirements.map((requirement: any) => {
            return {
              value: requirement.id || requirement.requirementId,
              text: requirement.requirement,
            };
          });

          // Combine unassigned option with filtered course requirements
          this.requirementOptions = [
            { value: null, text: 'Unassigned/Portfolio' },
            ...courseRequirementOptions,
          ];
        }
      });
    }
  }

  setRequirement = (requirement: any) => {
    this.selectedRequirement = requirement;
  }

  updateRequirement = () => {
    const requirementData = {
      registrationId: this.data.course.id,
      currentStatusKid: this.data.course.statusKid,
      loginName: this.data.selectedUser.loginName,
      requirementId: this.selectedRequirement,
    }

    const userCourseRequirementSubscription = this.coursesService.updateUserCourseRequirement(requirementData).subscribe({
      next: (response: any) => {
        this.toastService.setToast({ text: 'Course Requirement Updated', type: 'success' })
        this.dialog.closeAll();
      },
      error: (error: any) => {
        this.dialog.open(VerificationComponent, {
          data: {
            type: 'alert', title: 'Oops, something went wrong updating the course requirement', text: error.error.message,
          },
        })
      },
    })
  }

  closeDialog = () => {
    this.dialogRef.close();
  }

  ngOnDestroy(): void {
    this.courseDataSubscription?.unsubscribe();
    this.userCourseRequirementSubscription?.unsubscribe();
  }

}
